import { FunctionComponent } from "react";

import { Icon, IconProps } from "./icon";

export const WarningAlt: FunctionComponent<IconProps> = ({ className }) => {
    return (
        <Icon className={className}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M10.7058824,13.6502598 C10.7058824,14.9479855 9.65243471,16 8.35294118,16 C7.05344765,16 6,14.9479855 6,13.6502598 C6,12.3525341 7.05344765,11.3005196 8.35294118,11.3005196 C9.65243471,11.3005196 10.7058824,12.3525341 10.7058824,13.6502598 Z"
            ></path>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M6.57035294,1.8996789 C6.52714293,1.23607501 6.85713673,0.603556235 7.42649157,0.258666958 C7.99584642,-0.0862223193 8.71003594,-0.0862223193 9.27939078,0.258666958 C9.84874563,0.603556235 10.1787394,1.23607501 10.1355294,1.8996789 L9.84,7.54093522 C9.80015236,8.33106303 9.14703049,8.95127442 8.35482353,8.95127442 C7.56261657,8.95127442 6.9094947,8.33106303 6.86964706,7.54093522 L6.57035294,1.9015587 L6.57035294,1.8996789 Z"
            ></path>
        </Icon>
    );
};
